import {
  Component,
  OnInit,
  ElementRef,
  QueryList,
  ViewChildren,
  AfterViewInit,
  ChangeDetectorRef,
  HostListener,
  OnDestroy
} from '@angular/core';
import { ScratchCard } from './scratch-card.class';
import { ScratchCardConfig } from './scratch-card.models';
import { NgZone } from '@angular/core';
import { HttpClientService } from '../../../core/services/http-client.service';
import { ToastService } from '../../../core/services/toast.service';
import { CommonService } from '../../../core/services/common.service';

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.css']
})
export class OffersComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren('card') cards: QueryList<ElementRef<HTMLDivElement>>;

  public displayCanvas: boolean = true;
  offers: Array<any> = [];
  allGifts: Array<any> = [];
  currOfferData: any;
  images: any[] = [];
  responsiveOptions: any[] = [
    {
      breakpoint: '1200px',
      numVisible: 1,
      numScroll: 1
    },
    {
      breakpoint: '992px',
      numVisible: 1,
      numScroll: 1
    },
    {
      breakpoint: '768px',
      numVisible: 1,
      numScroll: 1
    },
    {
      breakpoint: '576px',
      numVisible: 1,
      numScroll: 1
    }
  ];

  private scratchCards: ScratchCard[] = [];
  private customerId: any;
  private androidId: any;
  private loader: boolean;

  constructor(
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private httpService: HttpClientService,
    private toast: ToastService,
    private common: CommonService
  ) {
    this.customerId = this.common.getStorage("customer").id;
    this.androidId = this.common.getStorage(this.common.androidlogId);
  }

  ngOnInit() {
    this.customerId = this.common.getStorage("customer").id;
    this.androidId = this.common.getStorage(this.common.androidlogId);
    this.loader = true;
    this.httpService.get("store/ScratchOffers", { id: this.customerId }).subscribe(
      (data) => {
        this.loader = false;
        for (let offer of data.response) {
          if (offer.offerName != null) {
            this.offers.push(offer);
          }
        }
      },
      (error) => {
        this.loader = false;
        this.toast.error("Something went wrong");
      }
    );
    this.currOffer();
    this.userGifts();
  }
  ngAfterViewInit(): void {
    this.initializeScratchCards();
    this.cards.changes.subscribe(() => this.initializeScratchCards());
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.onResize);
  }

  @HostListener('window:resize')
  onResize(): void {
    this.initializeScratchCards();
  }

  private initializeScratchCards(): void {
    this.scratchCards.forEach(sc => sc.destroy());
    this.scratchCards = [];

    this.cards.forEach((card, index) => {
      const gift = this.allGifts[index];
      if (!this.isGiftExpired(gift) && !gift.scratched && gift.status == "ACTIVE") {
        const scratchCard = this.initializeScratchCard(card.nativeElement, gift);
        this.scratchCards.push(scratchCard);
      }
    });
  }

  private initializeScratchCard(element: HTMLDivElement, gift: any): ScratchCard {
    const scConfig: ScratchCardConfig = {
      width: element.offsetWidth,
      height: element.offsetHeight,
      zoneRadius: 20,
      percentToFinish: 60,
      canvasClass: 'canvas',
      element: element,
      mask: 'assets/images/scratch-win-mask.jpeg',
      maskType: 'image',
      callback: () => {
        const canvas = element.querySelector('canvas');
        if (canvas) {
          canvas.style.display = 'none';
        }
        gift.scratched = true;
        gift.status = 'SCRATCHED';
        this.cdr.detectChanges();
        this.giftScrached(gift.scratchOfferId);
      },
    };

    const scratchCard = new ScratchCard(scConfig);
    this.ngZone.runOutsideAngular(() => scratchCard.init());
    return scratchCard;
  }
  getValidityClass(days: number): string {
    if (days <= 2) return 'validity-critical';
    if (days <= 7) return 'validity-warning';
    return 'validity-good';
  }
  isGiftExpired(gift: any): boolean {
    if (!gift) return false;
    if (gift.expired) return true;
    if (gift.status === 'EXPIRED') return true;
    if (gift.expiredTimestamp && new Date(gift.expiredTimestamp).getTime() < Date.now()) return true;
    return false;
  }
  getCardBackground(gift: any): string {
    if (this.isGiftExpired(gift) && !gift.scratched) {
      return 'url(assets/images/scratch-win-mask.jpeg)';
    }
    return 'url(https://apis.smartdukaan.com/document/' + gift.thumbnailUrl + ')';
  }
  private currOffer(): void {
    this.httpService.get("/store/current-offer").subscribe(
      (data) => {
        if (data.responseStatus === "SUCCESS") {
          this.currOfferData = data.response;
          if (this.currOfferData && this.currOfferData.offerImage) {
            const imageIds = this.currOfferData.offerImage.split(',');
            this.images = imageIds.map(imageId => {
              return {
                itemImageSrc: 'http://localhost:8080/document/' + imageId.trim(),
                alt: 'Offer Image',
                title: this.currOfferData.name || 'Offer'
              };
            });
          }
        }
      },
      (err) => {
      }
    );
  }

  private userGifts(): void {
    this.httpService.get("/store/giftsByCustomerId/" + this.customerId).subscribe(
      (data) => {
        for (let gift of data.response) {
          if (gift.offerName != null) {
            this.allGifts.push(gift);
          }
        }
      },
      (err) => {
        this.toast.error("Something went wrong");
      }
    );
  }
  private giftScrached(scratchOfferId): void {
    this.httpService.get("/store/offer/scratch/" + scratchOfferId).subscribe(
      (data) => {
       return data.response;
      },
      (err) => {
        this.toast.error("Something went wrong");
      }
    );
  }

  handleImageError(event: any): void {
    event.target.src = 'https://www.canadacasino.ca/wp-content/uploads/Online-scratch-cards-canada-casino.png';
    event.target.classList.add('image-error');
  }

  private scratched(id: number): void {
    this.httpService.post("/store/ScratchedOffer?id=" + id).subscribe(
      (data) => {
        if (data.responseStatus === "SUCCESS") {
          this.toast.success("Offer scratched successfully!");
        } else {
          this.toast.error("Problem creating. Please try after some time.");
        }
      },
      (err) => {
        this.toast.error("Something went wrong");
      }
    );
  }
}
